import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import API_URL from '../../config';

const ProfilePage = () => {
    // Déclaration de l'état pour stocker les données de l'utilisateur
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fonction pour récupérer les données utilisateur
    const fetchUserData = async () => {
        try {
            const response = await api.get(`${API_URL}/users/profile/`);  // Appel API pour récupérer les données
            setUserData(response.data);  // Mise à jour de l'état avec les données utilisateur
        } catch (err) {
            setError('Erreur lors du chargement des données utilisateur');
        } finally {
            setLoading(false);  // Fin du chargement, qu'il y ait eu une erreur ou non
        }
    };

    // Utilisation de useEffect pour déclencher la récupération des données au montage du composant
    useEffect(() => {
        fetchUserData();
    }, []);

    // Gestion de l'état de chargement, d'erreur et d'affichage des données
    if (loading) {
        return <div>Chargement des informations utilisateur...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div>
            <h1>Mon Profil</h1>
            {userData && (
                <div>
                    <p><strong>Nom :</strong> {userData.first_name} - {userData.last_name}</p>
                    <p><strong>Email :</strong> {userData.email}</p>
                    <p><strong>Date d'inscription :</strong> {new Date(userData.created_at).toLocaleDateString()}</p>
                    {/* Ajoute d'autres informations selon les données disponibles */}
                </div>
            )}
        </div>
    );
};

export default ProfilePage;